import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-zinc-500 hover:text-orange-400 text-sm mb-6 transition-colors"
          data-testid="privacy-back"
        >
          <ChevronLeft size={18} /> Retour
        </button>

        <h1 className="text-2xl font-bold text-white mb-2" data-testid="privacy-title">
          Politique de confidentialité
        </h1>
        <p className="text-zinc-500 text-sm mb-8">Dernière mise à jour : mars 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Données collectées</h2>
            <p className="mb-3">
              Dans le cadre de l'utilisation de Suivi BTP, les données suivantes peuvent être collectées :
            </p>
            <ul className="list-disc pl-5 space-y-1.5 text-zinc-400">
              <li><strong className="text-zinc-300">Informations entreprise :</strong> nom, adresse email, numéro de téléphone, adresse postale, numéro SIRET</li>
              <li><strong className="text-zinc-300">Données des utilisateurs :</strong> nom, prénom, adresse email professionnelle, rôle au sein de l'entreprise</li>
              <li><strong className="text-zinc-300">Données clients :</strong> nom, adresse, numéro de téléphone</li>
              <li><strong className="text-zinc-300">Informations liées aux chantiers :</strong> adresses, descriptions, dates, suivi des visites et observations</li>
              <li><strong className="text-zinc-300">Photos de chantier :</strong> images prises lors des visites de contrôle</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Finalité du traitement</h2>
            <p className="mb-3">Les données collectées sont utilisées exclusivement pour :</p>
            <ul className="list-disc pl-5 space-y-1.5 text-zinc-400">
              <li>Le suivi et la gestion des chantiers de construction</li>
              <li>L'organisation des interventions et visites de chantier</li>
              <li>La génération de rapports professionnels (PDF)</li>
              <li>La gestion des dossiers professionnels de l'entreprise utilisatrice</li>
              <li>L'administration des comptes utilisateurs</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Conservation des données</h2>
            <p className="text-zinc-400">
              Les données sont conservées uniquement dans le cadre de l'activité professionnelle
              de l'entreprise utilisatrice. Elles sont stockées de manière sécurisée sur une
              infrastructure cloud protégée. La suppression des données est possible sur simple
              demande auprès de notre service support.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Partage des données</h2>
            <ul className="list-disc pl-5 space-y-1.5 text-zinc-400">
              <li>Aucune revente de données à des tiers</li>
              <li>Aucune utilisation des données à des fins publicitaires</li>
              <li>L'accès aux données est strictement limité à l'entreprise utilisatrice</li>
              <li>Chaque entreprise ne peut accéder qu'à ses propres données (isolation complète)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Droits des utilisateurs</h2>
            <p className="mb-3">Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
            <ul className="list-disc pl-5 space-y-1.5 text-zinc-400">
              <li><strong className="text-zinc-300">Droit d'accès :</strong> vous pouvez demander une copie de vos données personnelles</li>
              <li><strong className="text-zinc-300">Droit de modification :</strong> vous pouvez demander la correction de données inexactes</li>
              <li><strong className="text-zinc-300">Droit de suppression :</strong> vous pouvez demander la suppression de vos données personnelles</li>
            </ul>
            <p className="mt-3 text-zinc-400">
              Pour exercer ces droits, contactez-nous à l'adresse indiquée ci-dessous.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Contact</h2>
            <p className="text-zinc-400">
              Pour toute question relative à la protection de vos données personnelles :
            </p>
            <p className="mt-2">
              <a href="mailto:support@avidomplus.com" className="text-orange-400 hover:text-orange-300 transition-colors">
                support@avidomplus.com
              </a>
            </p>
          </section>
        </div>

        <div className="border-t border-zinc-800 mt-10 pt-6 text-center text-zinc-600 text-xs">
          Suivi BTP — by AVIS DOM PLUS Conseil
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
